export default __webpack_public_path__ + "static/media/person-thumb-up.038687b6.png";